import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	position: relative;
`;

export const LayoutPage = styled.div`
	display: grid;
	width: 100%;
	background-color: white;
	padding: 20px;
`;

export const ExamsAlertContainer = styled.div`
	width: 100%;
	padding: 20px 0;
	margin-bottom: 20px;
`;

export const ExamAlert = styled.div`
	display: flex;
	width: 100%;
	background-color: ${tokens.color_white};
	padding: 20px 20px 20px 35px;
	border-radius: 6px;
	box-shadow: 0px 5px 10px 0px #d8dee6;
	img {
		width: 45px;
		height: 45px;
	}
`;

export const Separator = styled.hr`
	border: 1px solid ${tokens.color_ink_lightest};
	margin-top: 25px;
`;

export const ExamAlertText = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding-left: 30px;
	gap: 5px;
	p {
		color: ${tokens.color_gray_dark};
	}
	p:first-child {
		font-size: 18px;
	}
	p:last-child {
		font-size: 14px;
		button {
			cursor: pointer;
			color: ${tokens.color_toast_info};
			padding-left: 30px;
			text-decoration: underline;
		}
	}
`;
